import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appQuestionList]',
    standalone: false
})
export class QuestionListDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
